import apiFetch from '../apiFetch'
export default function (organizedUnitId, token, includeDeleted = false, selectedValue = null) {
  return apiFetch({ endPoint: `department/${organizedUnitId}?includeDeleted=${includeDeleted}&selectedValue=${selectedValue}`, method: 'GET', body: null, token: token })
}
